import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { userRoutes } from './lib.routes';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule, 
    MatDialogModule,
    RouterModule.forChild(userRoutes)
  ],
})
export class UserModule {}
